// SECURITY: HTML escape any string before interpolating into a popup HTML
// document built via window.open + document.write. Without this, tenant- or
// landlord-controlled values (name, address, lease terms) become persistent
// XSS sinks — and since the popup runs in the same origin, an injected
// script can read localStorage.auth_token and exfiltrate it.
export const escHtml = (s) =>
    String(s ?? '').replace(/[&<>"']/g, (c) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
    }[c]));

// Escape for use inside an HTML attribute value (e.g. href, src). Same as
// escHtml but emphasises intent at call sites.
export const escAttr = escHtml;
